import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import axiosPlugin from '@/lib/axios'

function decodeJwt(token: string) {
  try {
    const payloadBase64 = token.split('.')[1]
    const payloadJson = atob(payloadBase64)
    return JSON.parse(payloadJson)
  } catch {
    return null
  }
}

export function useAuthentication() {
  return {
    async beforeEnter(
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext,
    ) {
      try {
        const token = localStorage.getItem('access_token')
        if (!token) {
          return next({ name: 'login' })
        }

        const payload = decodeJwt(token)
        if (!payload) {
          return next({ name: 'login' })
        }

        // Check token expiration (exp is in seconds since epoch)
        const now = Math.floor(Date.now() / 1000)
        if (payload.exp && payload.exp < now) {
          return next({ name: 'login' })
        }

        // Set auth header for axios
        axiosPlugin.defaults.headers.common.Authorization = `Bearer ${token}`

        // Extract user roles from token if you want to do role-based guard
        // You can decode JWT here or store roles separately in sessionStorage

        const requiredRole = to.meta.requiresRole
        if (requiredRole === 'admin' && !payload.admin) {
          // User is not admin but route requires admin role
          return next({ name: 'dashboard' })
        }

        next()
      } catch (err) {
        console.error('Authentication error:', err)
        next({ name: 'login' })
      }
    },
  }
}
